const CLEAR_ENTRIES = '/pages/reports/events/CLEAR_ENTRIES'
const ADD_ENTRIES = '/pages/reports/events/ADD_ENTRIES'
const SET_COUNT = '/pages/reports/events/SET_COUNT'
const SET_OFFSET = '/page/reports/events/SET_OFFSET'
const SET_SORT_PARAMS = '/pages/reports/events/SET_SORT_PARAMS'
const SET_EVENT_INFO = '/pages/reports/events/SET_EVENT_INFO'

export default function reducer(state, action){

  const defaultState = {
    entries: {},
    offset: 0,
    count: 0,
    eventInfo: null,
    sortParams: [{field_name: 'timestamp', direction: 'desc'}]
  }

  if (!state) {
    state = defaultState
  }

  switch(action.type) {
    case CLEAR_ENTRIES:
      return {
        ...state,
        entries: {}
      }
    case ADD_ENTRIES:
      return {
        ...state,
        entries: {
          ...state.entries,
          ...action.data
        }
      }
    case SET_COUNT:
      return {
        ...state,
        count: action.data
      }
    case SET_OFFSET:
      return {
        ...state,
        offset: action.data
      }
    case SET_SORT_PARAMS:
      return {
        ...state,
        sortParams: action.data
      }
    case SET_EVENT_INFO:
      return {
        ...state,
        eventInfo: action.data
      }
    default:
      return state
  }
}

export const clearEntries = () => {
  return {
    type: CLEAR_ENTRIES
  }
}
export const addEntries = (entries) => {
  return {
    type: ADD_ENTRIES,
    data: entries
  }
}
export const setOffset = (value) => {
  return {
    type: SET_OFFSET,
    data: value
  }
}
export const setSortParams = (value) => {
  return {
    type: SET_SORT_PARAMS,
    data: value
  }
}
export const setCount = (value) => {
  return {
    type: SET_COUNT,
    data: value
  }
}
export const setEventInfo = (info) => {
  return {
    type: SET_EVENT_INFO,
    data: info
  }
}
export const getRequestParams = (filter) => (dispatch, getState) => {

  return filter
}